import { longpress } from './longpress.js';

/**
 * Svelte use: action that opens an element's menu the ways a person asks
 * for one: a long press on a touch screen (the click that ends it is
 * swallowed by `longpress`), a right-click with a mouse (Android also
 * reports its long press as one; opening twice is harmless), or the
 * keyboard's menu key / Shift+F10. The browser's own menu never shows.
 *
 * Usage: <button use:menupress={(el) => openMenu(id, el)}>; the menu gets
 * the element it opens from, to sit by it.
 *
 * @param {HTMLElement} node
 * @param {(node: HTMLElement) => void} open
 */
export function menupress(node, open) {
  let handler = open;
  const press = longpress(node, { onLongPress: () => handler(node) });

  /** @param {MouseEvent} e */
  function onContextMenu(e) {
    e.preventDefault();
    handler(node);
  }

  /** @param {KeyboardEvent} e */
  function onKeydown(e) {
    if (e.key === 'ContextMenu' || (e.shiftKey && e.key === 'F10')) {
      e.preventDefault();
      handler(node);
    }
  }

  node.addEventListener('contextmenu', onContextMenu);
  node.addEventListener('keydown', onKeydown);

  return {
    /** @param {(node: HTMLElement) => void} next */
    update(next) {
      handler = next;
    },
    destroy() {
      press.destroy();
      node.removeEventListener('contextmenu', onContextMenu);
      node.removeEventListener('keydown', onKeydown);
    },
  };
}
